import apiClient from '../client';
import type { Invoice, CreateInvoicePayload, NextReceiptNumberPayload, NextReceiptNumberResponse, UpdateInvoicePayload } from '@/types';

export const invoicesApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Invoice[], pagination: { total: number } }>('/invoices', { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: Invoice }>(`/invoices/${id}`).then((r) => r.data.data),

  getByAdmissionNo: (admissionNo: string) =>
    apiClient.get<{ data: Invoice[] }>(`/invoices/by-admission/${admissionNo}`)
      .then((r) => r.data.data),

  getNextReceiptNumber: (params: NextReceiptNumberPayload) =>
    apiClient.get<{ data: NextReceiptNumberResponse }>('/invoices/next-receipt-number', { params })
      .then((r) => r.data.data),

  create: (payload: CreateInvoicePayload) =>
    apiClient.post<{ data: Invoice }>('/invoices', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateInvoicePayload) =>
    apiClient.put<{ data: Invoice }>(`/invoices/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/invoices/${id}`),
};

